"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAmountWithCurrency = exports.getZeroValue = exports.getCurrencyFractionSeparator = exports.getCurrencySymbol = exports.SegmentCurrencySymbol = exports.getCurrency = exports.SegmentCurrency = exports.CurrencySymbol = exports.Currency = void 0;
const constants_1 = require("./constants");
var Currency;
(function (Currency) {
    Currency["GBP"] = "GBP";
    Currency["EUR"] = "EUR";
})(Currency = exports.Currency || (exports.Currency = {}));
var CurrencySymbol;
(function (CurrencySymbol) {
    CurrencySymbol["GBP"] = "\u00A3";
    CurrencySymbol["EUR"] = "\u20AC";
})(CurrencySymbol = exports.CurrencySymbol || (exports.CurrencySymbol = {}));
/**
 * Map between `Segment` and `Currency`
 */
exports.SegmentCurrency = Object.freeze({
    [constants_1.Segment.Fixter_UK]: Currency.GBP,
    [constants_1.Segment.Fixter_FR]: Currency.EUR,
});
const getCurrency = (segment) => exports.SegmentCurrency[segment] ?? Currency.GBP;
exports.getCurrency = getCurrency;
/**
 * Map between `Segment` and `CurrencySymbol`
 */
exports.SegmentCurrencySymbol = Object.freeze({
    [constants_1.Segment.Fixter_UK]: CurrencySymbol.GBP,
    [constants_1.Segment.Fixter_FR]: CurrencySymbol.EUR,
});
const getCurrencySymbol = (segment) => exports.SegmentCurrencySymbol[segment] ?? CurrencySymbol.GBP;
exports.getCurrencySymbol = getCurrencySymbol;
const getCurrencyFractionSeparator = (segment) => {
    switch (segment) {
        case constants_1.Segment.Fixter_FR:
            return ',';
        case constants_1.Segment.Fixter_UK:
        default:
            return '.';
    }
};
exports.getCurrencyFractionSeparator = getCurrencyFractionSeparator;
const getZeroValue = (segment) => {
    switch (segment) {
        case constants_1.Segment.Fixter_FR:
            return '0 €';
        case constants_1.Segment.Fixter_UK:
        default:
            return '£0';
    }
};
exports.getZeroValue = getZeroValue;
const formatAmountWithCurrency = (amount, segment, minimumFractionDigits = 2) => {
    const amountNumber = Number(amount);
    const isPreformattedAmount = Number.isNaN(amountNumber);
    if (isPreformattedAmount)
        return amount.toString();
    let formattedAmount;
    switch (segment) {
        case constants_1.Segment.Fixter_FR:
            formattedAmount = amountNumber.toLocaleString('fr-FR', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits,
            });
            break;
        case constants_1.Segment.Fixter_UK:
        default:
            formattedAmount = amountNumber.toLocaleString('gb-GB', {
                style: 'currency',
                currency: 'GBP',
                minimumFractionDigits,
            });
    }
    return formattedAmount.toString();
};
exports.formatAmountWithCurrency = formatAmountWithCurrency;
//# sourceMappingURL=currency.js.map